import axios, {AxiosResponse} from 'axios'
import {Order, OrderDetails, RemoveItemPayload} from '@interfaces/checkout'
import wcs from '@libs/wcs'
import {DataPrescriptionType} from '@store/types/prescription.types'
import {PrescriptionAddPayload} from '@interfaces//prescription'


export const getCartData = async ({
    storeId,
    catalogId,
    langId,
    timeStamp,
    }:{
    storeId: string,
    catalogId: string,
    langId: string,
    timeStamp: number,
}):Promise<AxiosResponse<Order> | undefined> => {
    try {
        return await axios
        .get(`/wcs/resources/store/${storeId}/cart/sgh/@self?catalogId=${catalogId}&langId=${langId}&storeId=${storeId}&_=${timeStamp}`)
    } catch (error) {
        console.error('Error getting cart data:', error)
    }
}
export const addItemToCart = async (payload:{
    [key: string]: string | number | boolean
}):Promise<AxiosResponse<OrderDetails> | undefined> => {
  try {
    return await axios
      .post(
        '/webapp/wcs/stores/servlet/AjaxOrderChangeServiceItemAdd',
        payload,
          {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
          },
      )
  } catch (error) {
    console.error('add item to cart api error:', error)
  }
}

export const addItemToRxCart = async (payload:DataPrescriptionType):Promise<AxiosResponse<any> | undefined> => {
  const hostname = window.location.hostname
  const { storeId } = wcs.getStoreConfig()
  try {
    return await axios
      .post(
        `https://${hostname}/wcs/resources/store/${storeId}/rx/cart`,
        payload,
      )
  } catch (error) {
    console.error('add to rx cart api error:', error)
  }
}


export const addToBagDataCalculate = async ({
  storeId,
  langId,
  orderItemId,
}: {
  storeId: string,
  langId: string,
  orderItemId: string,
}) => {
  const payload = {
    storeId,
    langId,
    updatePrices: '1',
    orderId: orderItemId,
    calculationUsage: '-1,-2,-3,-4,-5,-6,-7',
  }
  try {
    return await axios
      .post(
        '/webapp/wcs/stores/servlet/AjaxOrderCalculate',
        payload,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      )
  } catch (error) {
    console.error('Error calculating cart data:', error)
  }
}

export const updateOrderShippingInfo = async ({
  storeId,
  langId,
  catalogId,
  shipModeId,
}: {
  storeId: string,
  langId: string,
  catalogId: string,
  shipModeId: string,
}) => {
  const payload = {
    storeId,
    langId,
    catalogId,
    orderId: '.',
    calculationUsage: '-1,-2,-3,-4,-5,-6,-7',
    allocate: '***',
    backorder: '***',
    remerge: '***',
    check: '*n',
    doInventory: 'N',
    shipModeId,
  }
  try {
    return await axios
      .post(
        '/webapp/wcs/stores/servlet/AjaxOrderChangeServiceShipInfoUpdate',
        payload,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      )
  } catch (error) {
    console.error('update shipping method api error:', error)
  }
}


export const removeItemFromCart = async (payload:RemoveItemPayload):Promise<AxiosResponse<any> | undefined> => {
  const hostname = window.location.hostname
  try {
    return await axios
      .post(
        `https://${hostname}/webapp/wcs/stores/servlet/AjaxOrderChangeServiceItemDelete`,
        payload,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      )
  } catch (error) {
      console.error('remove item from cart api error:', error)
  }
}

export const addPrescription = async (payload:PrescriptionAddPayload):Promise<AxiosResponse<any> | undefined> => {
  try {
    const {storeId} = wcs.getStoreConfig()
    return await axios
      .post(
        `/wcs/resources/store/${storeId}/prescription`,
        payload,
      )
  } catch (error) {
    console.error('add prescription to cart api error:', error)
  }
}


